import React from "react";
import AbstractStep from "../../../stepper/AbstractStep";
import VerificationStep from "./steps/VerificationStep";
import SaisieStep from "./steps/SaisieStep";
import ValidationStep from "./steps/ValidationStep";

class InsuredSteps extends AbstractStep
{
    list = {
        0 : { name : 'Vérification des données' , component: <VerificationStep />},
        1 : { name : 'Saisie des informations', component: <SaisieStep />},
        2 : { name : 'Synthèse et validation', component: <ValidationStep />},
    }

}

export default InsuredSteps